import { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanCreateWorkFlow = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const createPermissionAll: UserPermission = {
    resource: 'workflows',
    action: 'createbasic',
    scope: 'all',
  };

  const canCreateAll = useHasPermission(user, createPermissionAll);
  return canCreateAll;
};
